module.exports = __webpack_public_path__ + "img/box.cdc1ab51.png";